import React from 'react';
interface CTASectionProps {
  variant?: 'primary' | 'final';
}
export function CTASection({
  variant = 'primary'
}: CTASectionProps) {
  if (variant === 'final') {
    return <div className="my-12 bg-gradient-to-br from-[#1E4D3D] to-[#163a2e] p-8 md:p-12 rounded-xl shadow-2xl text-white" data-id="element-31">
        <h2 className="text-3xl md:text-4xl font-bold mb-6 font-sans" data-id="element-32">
          The Choice Is Yours
        </h2>

        <div className="space-y-4 mb-8 text-white/90 leading-relaxed font-serif" data-id="element-33">
          <p data-id="element-34">You can stay where you are.</p>

          <p data-id="element-35">
            Keep drinking because you're too terrified to quit. Live with the
            constant fear that one day you'll try the wrong way and end up in
            the ER. Risk another seizure. Risk your life.
          </p>

          <p className="font-bold text-white" data-id="element-36">
            Or you can prepare your nervous system first.
          </p>

          <p data-id="element-37">
            Give your brain the GABA it needs. Calm the hyperexcitability before
            it becomes a seizure. Quit safely, at home, without the medical
            crisis.
          </p>

          <p data-id="element-38">
            This isn't about being "strong enough." You're already strong
            enough.
          </p>

          <p className="font-bold text-white" data-id="element-39">
            This is about being prepared enough.
          </p>

          <p data-id="element-40">Your nervous system needs biochemical support, not willpower.</p>
        </div>

        <div className="text-center mb-6" data-id="element-41">
          <p className="text-yellow-300 font-bold text-lg mb-2" data-id="element-42">
            Limited availability — Don't risk another day
          </p>
        </div>

        <a href="https://shopglisera.com/products/glisera-anti-alcohol-patch" className="w-full bg-yellow-400 hover:bg-yellow-300 text-gray-900 font-bold py-5 px-8 rounded-lg shadow-lg transition-all hover:scale-[1.02] text-center text-lg uppercase tracking-wide block" data-id="element-43">
          YES, I WANT TO PREPARE SAFELY
        </a>

        <p className="text-center text-white/70 text-sm mt-6" data-id="element-44">
          60-Day Satisfaction Guarantee | Secure Checkout | Discreet Shipping |
          Made in USA
        </p>
      </div>;
  }
  return <div className="my-12 bg-gray-50 p-6 md:p-8 rounded-xl border border-gray-200" data-id="element-45">
      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6 font-sans" data-id="element-46">
        Don't Wait Like I Did
      </h2>

      <p className="text-gray-700 mb-4 leading-relaxed font-serif" data-id="element-47">
        I almost died on my kitchen floor.
      </p>

      <p className="text-gray-700 mb-4 leading-relaxed font-serif" data-id="element-48">
        My daughter watched me convulse. The paramedics said I was lucky to be
        alive.
      </p>

      <p className="text-gray-700 mb-6 leading-relaxed font-serif" data-id="element-49">
        All because I tried to quit cold turkey without knowing about GABA
        depletion.
      </p>

      <p className="text-gray-700 mb-6 leading-relaxed font-serif font-bold" data-id="element-50">
        Now you know. Don't make the same mistake I did.
      </p>

      <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-8" data-id="element-51">
        <p className="text-red-800 text-sm md:text-base font-medium" data-id="element-52">
          <span className="font-bold" data-id="element-53">Medical Warning:</span> Alcohol withdrawal
          seizures can be fatal. The first 72 hours are the danger zone. Prepare
          your nervous system first.
        </p>
      </div>

      <div className="text-center mb-8" data-id="element-54">
        <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-55">
          What could one month mean for you?
        </h3>
        <ul className="text-left space-y-2 max-w-2xl mx-auto text-gray-700 font-serif" data-id="element-56">
          <li data-id="element-57">✓ Quitting safely without the $15,000 medical detox bill</li>
          <li data-id="element-58">✓ Making it past hour 36 without shaking or seizing</li>
          <li data-id="element-59">✓ Sleeping through the night without 3 AM panic</li>
          <li data-id="element-60">✓ Your children not watching you convulse</li>
          <li data-id="element-61">✓ Your nervous system prepared instead of in crisis</li>
          <li data-id="element-62">✓ Freedom from the fear of trying to quit</li>
        </ul>
      </div>

      <a href="https://shopglisera.com/products/glisera-anti-alcohol-patch" className="w-full bg-[#1E4D3D] hover:bg-[#163a2e] text-white font-bold py-4 px-6 rounded shadow-lg transition-transform hover:scale-[1.01] text-center text-sm md:text-base uppercase tracking-wide mb-4 block" data-id="element-63">
        CHECK AVAILABILITY NOW
      </a>

      <p className="text-center text-gray-600 text-sm" data-id="element-64">
        60-Day Money-Back Guarantee — If you don't make it through the 72-hour
        danger zone without crisis symptoms, return it for a full refund. No
        questions asked.
      </p>
    </div>;
}